/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import {
    HeadingColor,
    HeadingSize,
    HighlightColor,
} from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';

import { WrappedLink } from '@toucan/client/global/nextjs';

import { renderMarkdown } from '@toucan/client/shared/helpers/markdown';

import { AuthorCredit } from '@toucan/client/features/contentful/components/author-credit';
import { ContentfulPicture } from '@toucan/client/features/contentful/components/picture';

import { FeaturedArticle } from '../../config/types';
import { styles } from './featured-article-card.styles';

const StyledFeaturedArticleCard = styled.li`
    ${styles}
`;

export const FeaturedArticleCard = ({
    title,
    teaser,
    image,
    credits,
    link,
}: FeaturedArticle) => {
    const { t } = useTranslation();

    return (
        <StyledFeaturedArticleCard className="featured-article-card">
            <div className="featured-article-card__image">
                <ContentfulPicture image={image} />
            </div>
            <div className="featured-article-card__details">
                <Heading
                    size={HeadingSize.H3}
                    color={HeadingColor.TEXT_SECONDARY}
                    highlightColor={HighlightColor.TEXT_ACCENT}
                    className="featured-article-card__title"
                >
                    {renderMarkdown(title)}
                </Heading>
                {teaser && (
                    <p className="featured-article-card__teaser">{teaser}</p>
                )}
                <div className="featured-article-card__credits">
                    {credits.map(({ getText, ...credit }) => (
                        <AuthorCredit
                            key={getText('')}
                            getText={getText}
                            {...credit}
                        />
                    ))}
                </div>
                <WrappedLink
                    className="featured-article-card__link"
                    href={link.templatePath}
                    as={link.href}
                >
                    {t('Read article')}
                </WrappedLink>
            </div>
        </StyledFeaturedArticleCard>
    );
};
